<template>
  <div class="relative" :class="{ 'overflow-hidden': locked }" :style="{ height: locked ? 'calc(100vh - 140px)' : 'auto' }">
    <PreviewLockedOverlay 
      v-if="locked"
      class="absolute top-0 left-0 right-0 z-20"
      style="height: calc(100vh - 140px);"
      :title="`Start Tracking ${brand?.name || 'this brand'} to Unlock Timeline View`"
      description="Compare ad live durations with a gantt chart visualization."
      use-backdrop
      show-button-icon
    />
    <!-- FILTER BAR -->
    <div ref="filterBar" class="spyder-filter-bar is-timeline hidden sm:block bg-white bg-opacity-90 border-border-normal"
    style="backdrop-filter: blur(6px)" :style="{ zIndex: locked ? 0 : 40000 }">
      <FilterTopBar
        ref="filterTopBar"
        :class="{ 'pointer-events-none select-none': locked }"
        discovery
        :active-filters.sync="activeFilters"
        :selected-date-range.sync="selectedDateRange"
        :sort-order.sync="sortOrder"
        :text-search.sync="textSearch"
        @change="fetchAdvertisements"
      />
      <!-- Timeline axis / zoom controls -->
      <div class="flex">
        <div class="border-r border-t border-border-normal" style="width: 231px">
          <div class="flex gap-1 h-1/2 w-full border-border-normal items-center pl-3 border-b" style="margin-top: 0.5px">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path d="M4.515 17.1933L4.85549 16.5251H4.85549L4.515 17.1933ZM3.78664 16.465L4.45489 16.1245H4.45489L3.78664 16.465ZM17.1733 16.465L16.5051 16.1245L16.5051 16.1245L17.1733 16.465ZM16.445 17.1933L16.1045 16.5251L16.1045 16.5251L16.445 17.1933ZM17.1733 4.53502L16.5051 4.87551L16.5051 4.87551L17.1733 4.53502ZM16.445 3.80666L16.1045 4.47491L16.1045 4.47491L16.445 3.80666ZM3.78664 4.53502L3.11838 4.19452H3.11838L3.78664 4.53502ZM4.515 3.80666L4.1745 3.1384H4.1745L4.515 3.80666ZM16.605 6.29167V14.7083H18.105V6.29167H16.605ZM14.6883 16.625H6.27165V18.125H14.6883V16.625ZM4.35498 14.7083V6.29167H2.85498V14.7083H4.35498ZM6.27165 4.375H14.6883V2.875H6.27165V4.375ZM6.27165 16.625C5.79256 16.625 5.47835 16.6244 5.23806 16.6048C5.00652 16.5859 4.9104 16.5531 4.85549 16.5251L4.1745 17.8616C4.47611 18.0153 4.79161 18.0733 5.11591 18.0998C5.43146 18.1256 5.81731 18.125 6.27165 18.125V16.625ZM2.85498 14.7083C2.85498 15.1627 2.8544 15.5485 2.88018 15.8641C2.90667 16.1884 2.9647 16.5039 3.11838 16.8055L4.45489 16.1245C4.42691 16.0696 4.39411 15.9735 4.3752 15.7419C4.35556 15.5016 4.35498 15.1874 4.35498 14.7083H2.85498ZM4.85549 16.5251C4.68301 16.4372 4.54278 16.297 4.45489 16.1245L3.11838 16.8055C3.35007 17.2602 3.71978 17.6299 4.1745 17.8616L4.85549 16.5251ZM16.605 14.7083C16.605 15.1874 16.6044 15.5016 16.5848 15.7419C16.5658 15.9735 16.533 16.0696 16.5051 16.1245L17.8416 16.8055C17.9953 16.5039 18.0533 16.1884 18.0798 15.8641C18.1056 15.5485 18.105 15.1627 18.105 14.7083H16.605ZM14.6883 18.125C15.1426 18.125 15.5285 18.1256 15.8441 18.0998C16.1684 18.0733 16.4838 18.0153 16.7855 17.8616L16.1045 16.5251C16.0496 16.5531 15.9534 16.5859 15.7219 16.6048C15.4816 16.6244 15.1674 16.625 14.6883 16.625V18.125ZM16.5051 16.1245C16.4172 16.297 16.277 16.4372 16.1045 16.5251L16.7855 17.8616C17.2402 17.6299 17.6099 17.2602 17.8416 16.8055L16.5051 16.1245ZM18.105 6.29167C18.105 5.83733 18.1056 5.45147 18.0798 5.13593C18.0533 4.81163 17.9953 4.49613 17.8416 4.19452L16.5051 4.87551C16.533 4.93042 16.5658 5.02654 16.5848 5.25808C16.6044 5.49837 16.605 5.81258 16.605 6.29167H18.105ZM14.6883 4.375C15.1674 4.375 15.4816 4.37558 15.7219 4.39522C15.9534 4.41413 16.0496 4.44693 16.1045 4.47491L16.7855 3.1384C16.4838 2.98472 16.1684 2.92669 15.8441 2.9002C15.5285 2.87442 15.1426 2.875 14.6883 2.875V4.375ZM17.8416 4.19452C17.6099 3.7398 17.2402 3.37009 16.7855 3.1384L16.1045 4.47491C16.277 4.5628 16.4172 4.70303 16.5051 4.87551L17.8416 4.19452ZM4.35498 6.29167C4.35498 5.81258 4.35556 5.49837 4.3752 5.25808C4.39411 5.02654 4.42691 4.93042 4.45489 4.87551L3.11838 4.19452C2.9647 4.49613 2.90667 4.81163 2.88018 5.13593C2.8544 5.45147 2.85498 5.83733 2.85498 6.29167H4.35498ZM6.27165 2.875C5.81731 2.875 5.43146 2.87442 5.11591 2.9002C4.79161 2.92669 4.47611 2.98472 4.1745 3.1384L4.85549 4.47491C4.9104 4.44693 5.00652 4.41413 5.23806 4.39522C5.47835 4.37558 5.79256 4.375 6.27165 4.375V2.875ZM4.45489 4.87551C4.54278 4.70303 4.68301 4.56279 4.85549 4.47491L4.1745 3.1384C3.71978 3.37009 3.35008 3.7398 3.11838 4.19452L4.45489 4.87551Z" fill="#5E6678" />
              <path d="M11.0366 13.2917C10.6224 13.2917 10.2866 13.6275 10.2866 14.0417C10.2866 14.456 10.6224 14.7917 11.0366 14.7917L11.0366 13.2917ZM14.0366 14.7917C14.4508 14.7917 14.7866 14.456 14.7866 14.0417C14.7866 13.6275 14.4508 13.2917 14.0366 13.2917L14.0366 14.7917ZM11.0366 14.7917L14.0366 14.7917L14.0366 13.2917L11.0366 13.2917L11.0366 14.7917Z" fill="#5E6678" />
              <path d="M7.97998 9.75708C7.56577 9.75708 7.22998 10.0929 7.22998 10.5071C7.22998 10.9213 7.56577 11.2571 7.97998 11.2571V9.75708ZM12.98 11.2571C13.3942 11.2571 13.73 10.9213 13.73 10.5071C13.73 10.0929 13.3942 9.75708 12.98 9.75708V11.2571ZM7.97998 11.2571H12.98V9.75708H7.97998V11.2571Z" fill="#5E6678" />
              <path d="M6.93848 6.22266C6.52426 6.22266 6.18848 6.55844 6.18848 6.97266C6.18848 7.38687 6.52426 7.72266 6.93848 7.72266V6.22266ZM9.93848 7.72266C10.3527 7.72266 10.6885 7.38687 10.6885 6.97266C10.6885 6.55844 10.3527 6.22266 9.93848 6.22266V7.72266ZM6.93848 7.72266H9.93848V6.22266H6.93848V7.72266Z" fill="#5E6678" />
            </svg>
            <BaseText type="label" size="sm" class="text-text-muted">
              Timeline
            </BaseText>
          </div>
          <div class="flex gap-2 h-1/2 w-full border-border-normal items-center px-2 justify-end">
            <button class="flex items-center justify-center w-1/2 h-6 rounded border border-border-hover"
            @click="zoomOut">
              -
            </button>
            <button class="flex items-center justify-center w-1/2 h-6 rounded border border-border-hover"
            @click="zoomIn">
              +
            </button>
          </div>
        </div>
        <div class="flex py-2.5 flex-col border-t border-border-normal gantt-timeaxis-animation overflow-y-visible overflow-x-hidden"
        style="width: calc(100% - 233px)">
          <div class="border-border-normal flex items-center justify-end w-full h-px border-b pt-7 mb-2" />
          <div class="flex items-center w-full justify-around pl-4">
            <div v-for="(item, index) in dateRange" :key="index" class="relative flex justify-end"
            :class="currentZoom === 'year' && 'h-5'" :style="{ width: item.widthPercentage + '%' }">
              <!-- Display day -->
              <BaseText v-if="currentZoom !== 'year'" type="body" size="sm" class="text-neutral-500 rounded select-none">
                {{ item.day }}
              </BaseText>
              <!-- Display month (if available) -->
              <div v-if="item.month" class="absolute -top-10" :class="{ 'left-5': currentZoom === 'month', 'left-20 pl-5': currentZoom === 'week', 'left-1': currentZoom === 'year' }">
                <BaseText type="label" size="sm" class="text-text-muted px-1 rounded cursor-default -top-12 select-none">
                  {{ item.month }}
                </BaseText>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- CONTENT -->
    <div class="pb-4" :class="{ 'pl-4': locked }">
      <AdvertisementGanttList v-if="advertisements.length"
        :class="{ 'pointer-events-none select-none': locked }"
        discovery
        :advertisements="advertisements"
        :my-chart-start="myChartStart"
        :my-chart-end="myChartEnd"
        :current-zoom="currentZoom"
        :zoom-in="zoomIn"
        @getMoreAds="() => getMoreAds({})"
        @update:myChartStart="myChartStart = $event"
        @update:myChartEnd="myChartEnd = $event"
      />
      <SpyderEmptyState
        v-else-if="!loadingAdvertisements"
        class="mt-24"
        :filters-applied="filtersApplied"
        :has-search-query="textSearch.length > 0"
        @clearFilters="clearFilters"
      />
      <BaseLoadingLogo v-if="loadingAdvertisements && !advertisements.length" />
      <infinite-loading
        v-if="advertisements.length && !locked"
        :identifier="infiniteId"
        @infinite="getMoreAds"
      >
        <div slot="spinner">
          <BaseLoadingLogo :margin="2" />
        </div>
        <div slot="no-more" />
        <div slot="no-results" />
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import ForeplayAPI from '@/api/foreplayServer'
import { checkAndCacheAll, clearUniqueCreatives } from '@/db/UniqueCreativesDB'
import InfiniteLoading from 'vue-infinite-loading'
import EventBus from '@/plugins/BaseNotifications/EventBus'

import AdvertisementGanttList from '../../advertisements/AdvertisementGanttList.vue'
import SpyderEmptyState from '../SpyderEmptyState.vue'
import FilterTopBar from '../../search/FilterTopBar.vue'
import PreviewLockedOverlay from '../PreviewLockedOverlay.vue'

export default {
  name: 'TimelineBrandView',
  components: {
    AdvertisementGanttList,
    SpyderEmptyState,
    FilterTopBar,
    PreviewLockedOverlay,
    InfiniteLoading
  },
  props: {
    brand: {
      type: Object,
      default: () => ({})
    },
    // Mirrors SpyderView's overage modal state; gates pagination while active.
    blocked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // Data States
      advertisements: [],

      // Pagination States
      lastDocId: null,
      infiniteId: +new Date(),

      // Loading States
      loadingAdvertisements: true,
      allAdsLoaded: false,

      // Filter Bar States
      textSearch: '',
      activeFilters: {},
      selectedDateRange: {
        start: null,
        end: null
      },
      sortOrder: [{ name: 'Newest', value: 'desc' }],

      // Timeline Toolbar States
      myChartStart: null,
      myChartEnd: null,
      currentZoom: 'month'
    }
  },
  watch: {
    // Grouping toggled here or in Settings > Preferences
    getUniqueCreatives () {
      this.fetchAdvertisements()
    }
  },
  computed: {
    ...mapGetters('MiscModule', ['getUniqueCreatives']),
    locked () {
      const isSubscribed = this.brand?.is_subscribed
      return isSubscribed === undefined ? false : !isSubscribed
    },
    filtersApplied () {
      return Object.keys(this.activeFilters).length > 0 || this.textSearch.length > 0
    },
    dateRange () {
      const startDate = moment(this.myChartStart).startOf('day')
      const endDate = moment(this.myChartEnd).endOf('day')
      const result = []
      let currentMonth = ''

      const totalDays = endDate.diff(startDate, 'days') + 1
      const widthPercentage = 100 / totalDays

      while (startDate.isSameOrBefore(endDate, 'day')) {
        if (this.currentZoom !== 'year') {
          const currentItem = {
            day: startDate.format('D'),
            widthPercentage,
            barLeftPosition: this.mapTimeToPosition(startDate),
            barWidth: this.mapTimeToPosition(startDate.clone().add(1, 'days'))
          }
          if ((startDate.date() === 1 || startDate.isSame(startDate.clone().startOf('month'), 'day')) && startDate.format('MMMM') !== currentMonth) {
            currentItem.month = startDate.format(this.currentZoom === 'year' ? 'MMM' : 'MMMM')
            currentMonth = startDate.format('MMMM')
          }
          result.push(currentItem)
        } else {
          if (startDate.date() === 1 && startDate.format('MMMM') !== currentMonth) {
            const monthDays = startDate.daysInMonth()
            const monthWidthPercentage = widthPercentage * monthDays
            const monthItem = {
              month: startDate.format('MMM'),
              widthPercentage: monthWidthPercentage,
              barLeftPosition: this.mapTimeToPosition(startDate),
              barWidth: this.mapTimeToPosition(startDate.clone().add(monthDays, 'days'))
            }
            currentMonth = startDate.format('MMMM')
            result.push(monthItem)
          }
        }
        startDate.add(1, 'day')
      }
      return result
    }
  },
  mounted () {
    this.myChartStart = moment().startOf('day').subtract(30, 'days').format('YYYY-MM-DD HH:mm')
    this.myChartEnd = moment().startOf('day').format('YYYY-MM-DD HH:mm')
    this.fetchAdvertisements()
    EventBus.$on('spyder:scroll', this.handleScroll)
  },
  beforeDestroy () {
    EventBus.$off('spyder:scroll', this.handleScroll)
  },
  methods: {
    async fetchAdvertisements (load = true, refresh = false) {
      this.loadingAdvertisements = load
      this.advertisements = []

      await clearUniqueCreatives()

      const ranBetweenStart = +new Date(this.selectedDateRange?.start) || null
      const ranBetweenEnd = +new Date(this.selectedDateRange?.end) || null
      if (refresh) {
        this.lastDocId = null
      }
      try {
        const { data: results, nextPage } = await ForeplayAPI.Ads.getSpyderAds(
          this.$route.params.id, 
          null, 
          {
            ...this.activeFilters,
            ranBetweenStart,
            ranBetweenEnd,
            textSearch: this.textSearch,
            sort: this.sortOrder[0].value,
            size: 20
          }
        )

        this.lastDocId = nextPage

        if (this.getUniqueCreatives) {
          const uniqueCreatives = await checkAndCacheAll(results)
          this.advertisements = uniqueCreatives
        } else {
          this.advertisements = results
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingAdvertisements = false
        this.infiniteId += 1
      }
    },
    async getMoreAds ($state) {
      if (this.blocked || this.locked) {
        return
      }

      if (!this.lastDocId) {
        if (Object.keys($state).length) {
          $state.complete()
        }
        this.allAdsLoaded = true
        return
      }

      const ranBetweenStart = +new Date(this.selectedDateRange.start) || null
      const ranBetweenEnd = +new Date(this.selectedDateRange.end) || null
      const { data: results, nextPage } = await ForeplayAPI.Ads.getSpyderAds(
        this.$route.params.id, 
        this.lastDocId, 
        {
          ...this.activeFilters,
          ranBetweenStart,
          ranBetweenEnd,
          textSearch: this.textSearch,
          sort: this.sortOrder[0].value
        }
      )
      this.lastDocId = nextPage

      if (!this.lastDocId) {
        if (Object.keys($state).length) {
          $state.complete()
        }
        return
      }

      if (this.getUniqueCreatives) {
        const uniqueCreatives = await checkAndCacheAll(results)
        this.advertisements = [...this.advertisements, ...uniqueCreatives]
      } else {
        this.advertisements = [...this.advertisements, ...results]
      }

      if (Object.keys($state).length) {
        $state.loaded()
      }
    },
    async clearFilters () {
      const filterTopBar = this.$refs.filterTopBar
      filterTopBar.clearAllFilters()
      this.textSearch = ''

      await this.fetchAdvertisements()

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    },
    zoomIn () {
      if (this.locked) return
      const today = moment().startOf('day')
      const isEndToday = moment(this.myChartEnd).isSame(today, 'day')
      const midPoint = moment(this.myChartStart).add(moment(this.myChartEnd).diff(moment(this.myChartStart)) / 2)

      if (isEndToday) {
        if (this.currentZoom === 'month') {
          this.myChartStart = today.clone().subtract(7, 'days').format('YYYY-MM-DD HH:mm')
          this.myChartEnd = today.format('YYYY-MM-DD HH:mm')
          this.currentZoom = 'week'
        } else if (this.currentZoom === 'year') {
          this.myChartStart = today.clone().subtract(1, 'month').format('YYYY-MM-DD HH:mm')
          this.myChartEnd = today.format('YYYY-MM-DD HH:mm')
          this.currentZoom = 'month'
        }
      } else {
        if (this.currentZoom === 'month') {
          this.myChartStart = midPoint.clone().subtract(7.5, 'days').format('YYYY-MM-DD HH:mm')
          this.myChartEnd = midPoint.clone().add(7.5, 'days').format('YYYY-MM-DD HH:mm')
          this.currentZoom = 'week'
        } else if (this.currentZoom === 'year') {
          this.myChartStart = midPoint.clone().subtract(15, 'days').format('YYYY-MM-DD HH:mm')
          this.myChartEnd = midPoint.clone().add(15, 'days').format('YYYY-MM-DD HH:mm')
          this.currentZoom = 'month'
        }
      }
    },
    zoomOut () {
      if (this.locked) return
      const today = moment().startOf('day')
      const midPoint = moment(this.myChartStart).add(moment(this.myChartEnd).diff(moment(this.myChartStart)) / 2)

      const calculateNewEnd = (increment) => midPoint.clone().add(increment, 'days')

      let endAfterToday = false // Initialize variable at the beginning

      if (this.currentZoom === 'week') {
        const newEnd = calculateNewEnd(15)
        endAfterToday = newEnd.isSameOrAfter(today)
      } else if (this.currentZoom === 'month') {
        const newEnd = calculateNewEnd(6 * 30) // Assuming an average of 30 days per month
        endAfterToday = newEnd.isSameOrAfter(today)
      }

      if (endAfterToday) {
        if (this.currentZoom === 'week') {
          this.myChartStart = today.clone().subtract(1, 'month').format('YYYY-MM-DD HH:mm')
          this.myChartEnd = today.format('YYYY-MM-DD HH:mm')
          this.currentZoom = 'month'
        } else if (this.currentZoom === 'month') {
          this.myChartStart = today.clone().subtract(1, 'year').format('YYYY-MM-DD HH:mm')
          this.myChartEnd = today.format('YYYY-MM-DD HH:mm')
          this.currentZoom = 'year'
        }
        return
      }

      // Existing zoom out logic
      if (this.currentZoom === 'week') {
        this.myChartStart = midPoint.clone().subtract(15, 'days').format('YYYY-MM-DD HH:mm')
        this.myChartEnd = midPoint.clone().add(15, 'days').format('YYYY-MM-DD HH:mm')
        this.currentZoom = 'month'
      } else if (this.currentZoom === 'month') {
        this.myChartStart = midPoint.clone().subtract(6, 'months').format('YYYY-MM-DD HH:mm')
        this.myChartEnd = midPoint.clone().add(6, 'months').format('YYYY-MM-DD HH:mm')
        this.currentZoom = 'year'
      }
    },
    mapTimeToPosition (time) {
      const start = moment(this.myChartStart)
      const end = moment(this.myChartEnd)

      const totalHourCount = end.diff(start, 'hours', true)

      const hourDiffFromStart = moment(time).diff(start, 'hours', true)
      const positionPercentage = (hourDiffFromStart / totalHourCount) * 100

      return positionPercentage
    },
    handleScroll (position) {
      const bar = this.$refs.filterBar
      if (!bar) return

      // Timeline view uses a flush, full-width sticky bar (no margin or border-radius transition)
      bar.style.marginLeft = '0px'
      bar.style.marginRight = '0px'
      bar.style.marginTop = '0px'

      const shadowSection = (maxValue) => {
        return position.scrollTop / 15 < maxValue ? position.scrollTop / 15 : maxValue
      }

      if (position.scrollTop) {
        bar.style.boxShadow = `rgba(0, 0, 0, 0.08) 0px ${shadowSection(
          15
        )}px ${shadowSection(55)}px, rgba(0, 0, 0, 0.08) 0px -${shadowSection(
          7
        )}px ${shadowSection(
          10
        )}px, rgba(0, 0, 0, 0.08) 0px 4px 6px, rgba(0, 0, 0, 0.08) 0px ${shadowSection(
          7
        )}px ${shadowSection(13)}px, rgba(0, 0, 0, 0.08) 0px -${shadowSection(
          3
        )}px ${shadowSection(5)}px`
      } else {
        bar.style.boxShadow = null
      }
    }
  }
}
</script>

<style scoped>
.spyder-filter-bar {
  position: sticky;
  top: 16px;
}
.spyder-filter-bar.is-timeline {
  top: 0px;
}
</style>
